// Legal Skills organized by subcategories
export const LEGAL_SKILLS_CATEGORIES = [
  {
    name: 'Legal Research and Analysis',
    skills: [
      'Legal Research', 'Case Analysis', 'Statutory Interpretation',
      'Legal Writing', 'Legal Documentation', 'Precedent Analysis',
      'Legal Reasoning', 'Critical Analysis', 'Legislative Research',
      'Document Review', 'Legal Citation', 'Research Methodology',
      'Case Law Research', 'Regulatory Research', 'Legal Analysis'
    ]
  },
  {
    name: 'Litigation and Advocacy',
    skills: [
      'Trial Advocacy', 'Courtroom Presentation', 'Legal Arguments',
      'Evidence Handling', 'Witness Examination', 'Trial Preparation',
      'Oral Advocacy', 'Motion Practice', 'Negotiation Skills',
      'Mediation Skills', 'Arbitration', 'Dispute Resolution',
      'Legal Strategy', 'Case Management', 'Settlement Negotiation'
    ]
  },
  {
    name: 'Contract Law',
    skills: [
      'Contract Drafting', 'Contract Review', 'Contract Negotiation',
      'Contract Management', 'Terms and Conditions', 'Agreement Preparation',
      'Contract Analysis', 'Contract Enforcement', 'Contract Compliance',
      'Commercial Contracts', 'Licensing Agreements', 'Service Agreements',
      'Employment Contracts', 'Contract Templates', 'Contract Administration'
    ]
  },
  {
    name: 'Corporate Law',
    skills: [
      'Corporate Governance', 'Business Law', 'Securities Law',
      'Mergers and Acquisitions', 'Corporate Compliance', 'Regulatory Compliance',
      'Corporate Structure', 'Shareholder Rights', 'Board Governance',
      'Corporate Transactions', 'Due Diligence', 'Corporate Documentation',
      'Corporate Policy', 'Corporate Strategy', 'Business Formation'
    ]
  },
  {
    name: 'Intellectual Property',
    skills: [
      'Patent Law', 'Trademark Law', 'Copyright Law',
      'IP Protection', 'IP Strategy', 'IP Portfolio Management',
      'IP Litigation', 'IP Licensing', 'Trade Secrets',
      'IP Registration', 'IP Enforcement', 'IP Due Diligence',
      'IP Research', 'IP Documentation', 'IP Compliance'
    ]
  },
  {
    name: 'Regulatory Compliance',
    skills: [
      'Compliance Management', 'Regulatory Analysis', 'Risk Assessment',
      'Policy Development', 'Compliance Training', 'Audit Management',
      'Regulatory Reporting', 'Compliance Documentation', 'Investigation Management',
      'Compliance Monitoring', 'Regulatory Updates', 'Compliance Strategy',
      'Compliance Programs', 'Regulatory Relations', 'Compliance Testing'
    ]
  },
  {
    name: 'Employment Law',
    skills: [
      'Labor Relations', 'Employment Rights', 'Workplace Compliance',
      'HR Policies', 'Employee Relations', 'Discrimination Law',
      'Workplace Safety', 'Benefits Law', 'Employment Contracts',
      'Labor Disputes', 'Union Relations', 'Employment Litigation',
      'Workers Compensation', 'Employment Policy', 'Workplace Investigations'
    ]
  },
  {
    name: 'International Law',
    skills: [
      'International Trade', 'Cross-border Transactions', 'International Contracts',
      'Trade Compliance', 'International Relations', 'Treaty Law',
      'International Disputes', 'Global Compliance', 'International Business',
      'Foreign Law', 'International Arbitration', 'Trade Regulations',
      'International Policy', 'Global Strategy', 'International Agreements'
    ]
  },
  {
    name: 'Legal Technology',
    skills: [
      'Legal Software', 'E-discovery', 'Legal Research Tools',
      'Case Management Systems', 'Document Management', 'Legal Analytics',
      'Legal Databases', 'Legal Tech Innovation', 'Digital Evidence',
      'Legal Automation', 'Compliance Software', 'Legal Data Analysis',
      'Legal Tech Strategy', 'Legal Tech Implementation', 'Legal Tech Support'
    ]
  },
  {
    name: 'Ethics and Professional Responsibility',
    skills: [
      'Legal Ethics', 'Professional Conduct', 'Ethical Decision Making',
      'Client Relations', 'Confidentiality', 'Conflict Management',
      'Professional Standards', 'Ethical Compliance', 'Attorney Ethics',
      'Client Communication', 'Ethical Leadership', 'Professional Development',
      'Ethical Guidelines', 'Professional Integrity', 'Ethical Practice'
    ]
  },
  {
    name: 'Legal Project Management',
    skills: [
      'Case Management', 'Legal Operations', 'Project Planning',
      'Resource Management', 'Timeline Management', 'Budget Management',
      'Team Coordination', 'Quality Control', 'Risk Management',
      'Process Improvement', 'Performance Tracking', 'Project Documentation',
      'Stakeholder Management', 'Project Strategy', 'Project Execution'
    ]
  },
  {
    name: 'Legal Communication',
    skills: [
      'Legal Writing', 'Client Communication', 'Court Communications',
      'Professional Correspondence', 'Legal Presentations', 'Documentation Skills',
      'Stakeholder Communication', 'Legal Reporting', 'Communication Strategy',
      'Legal Drafting', 'Technical Writing', 'Legal Translation',
      'Communication Planning', 'Legal Terminology', 'Communication Standards'
    ]
  }
];

// Export flattened list for backward compatibility
export const LEGAL_SKILLS = LEGAL_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
